import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosGet, axiosPut } from '../utils/api';

export const getTermsAndConditionsList = ({ accessToken, params } = {}) =>
  queryOptions({
    queryKey: ['/terms-and-conditions', params],
    queryFn: async () => {
      const res = await axiosGet('/terms-and-conditions', { params }, accessToken);
      return res.data;
    },
    staleTime: 2 * 60 * 1000, // 2 min - avoid duplicate fetches on remount (e.g. Strict Mode)
  });

/** Public: get terms by type ('client' | 'lead') */
export const getTermsByType = (type) =>
  queryOptions({
    queryKey: ['/terms-and-conditions/type', type],
    queryFn: async () => {
      const res = await axiosGet(`/terms-and-conditions/type/${type}`);
      return res.data;
    },
    enabled: !!type && (type === 'client' || type === 'lead'),
    staleTime: 2 * 60 * 1000, // 2 min - avoid duplicate fetches on remount
  });

export const useUpdateTermsByType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ type, content }) => axiosPut(`/terms-and-conditions/type/${type}`, { content }),
    onSuccess: (_, { type }) => {
      queryClient.invalidateQueries({ queryKey: ['/terms-and-conditions'] });
      queryClient.invalidateQueries({ queryKey: ['/terms-and-conditions/type', type] });
    },
  });
};
